import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=36da8a6b&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=36da8a6b&prod&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=36da8a6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da8a6b",
  null
  
)

export default component.exports